<script setup lang="ts">
import { ref, watch } from "vue"
const today = new Date()
const year = today.getFullYear()
const month = (today.getMonth() + 1).toString().padStart(2, "0")
const day = today.getDate().toString().padStart(2, "0")
let imageSrc = ref("https://rimes.int/themes/custom/rimestheme/dist/assets/img/empty.png")
let intervalId: null | undefined
let paused = ref(false)
let date = `${year}-${month}-${day}`
let country = "Afghanistan"
let countries = [
  { value: "Afghanistan", text: "Afghanistan" },
  { value: "Bangladesh", text: "Bangladesh" },
  { value: "CHAD", text: "CHAD" },
  { value: "Cambodia", text: "Cambodia" },
  { value: "Comoros", text: "Comoros" },
  { value: "Djibouti", text: "Djibouti" },
  { value: "Kenya", text: "Kenya" },
  { value: "Lao%20PDR", text: "Lao PDR" },
  { value: "Madagascar", text: "Madagascar" },
  { value: "Maldives", text: "Maldives" },
  { value: "Mongolia", text: "Mongolia" },
  { value: "Mozambique", text: "Mozambique" },
  { value: "Myanmar", text: "Myanmar" },
  { value: "Nepal", text: "Nepal" },
  { value: "Papua%20New%20Guinea", text: "Papua New Guinea" },
  { value: "Philippines", text: "Philippines" },
  { value: "Seychelles", text: "Seychelles" },
  { value: "Sri%20Lanka", text: "Sri Lanka" },
  { value: "Timor-Leste", text: "Timor-Leste" },
  { value: "Tonga", text: "Tonga" },
  { value: "Yemen", text: "Yemen" },
]
let parameter = "rf"
let parameters = [
  { value: "rf", text: "RainFall" },
  { value: "temp", text: "Temperature" },
  { value: "ws10", text: "Wind Speed" },
]
let stepNumber = ref(4)
function next() {
  stepNumber.value = stepNumber.value < 28 ? stepNumber.value + 1 : (stepNumber.value = 4)
}
function prev() {
  stepNumber.value = stepNumber.value === 4 ? 28 : stepNumber.value - 1
}
function pause() {
  if (intervalId) {
    clearInterval(intervalId)
    intervalId = null
  } else {
    updateImageSrc()
  }
  paused.value = !paused.value
}
function updateImageSrc() {
  // const dateObj = new Date(this.date);
  const dateStrs = date.replace(/-/g, "-")
  const dateStr = date.replace(/-/g, "")
  let stepNumberFormatted = stepNumber.value < 10 ? `0${stepNumber.value}` : stepNumber.value
  imageSrc.value = `https://plots.rimes.int/${dateStrs}/${country}/${parameter}_${dateStr}_12_step-${stepNumberFormatted}.png`
}
function imageLoadOnError(e: any) {
  const target = e.target as HTMLImageElement
  target.src = "https://rimes.int/themes/custom/rimestheme/dist/assets/img/empty.png"
}
updateImageSrc()
intervalId = <any>setInterval(next, 1500)

watch(stepNumber, (newValue, oldValue) => {
  if (newValue !== oldValue) {
    updateImageSrc()
  }
})
</script>

<template>
  <div class="container">
    <div class="row">
      <div class="col-4">
        <label for="datepicker">Date:</label>
        <input type="date" class="form-c" id="datepicker" v-model="date" />
      </div>
      <div class="col-4">
        <label for="country">Country:</label>
        <select class="form-c" id="country" v-model="country">
          <option v-for="(country, index) in countries" :key="index" :value="country.value">{{ country.text }}</option>
        </select>
      </div>
      <div class="col-4">
        <label for="parameter">Parameter:</label>
        <select class="form-c" id="parameter" v-model="parameter">
          <option v-for="(parameter, index) in parameters" :key="index" :value="parameter.value">
            {{ parameter.text }}
          </option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <img :src="imageSrc" :alt="imageSrc" @error="imageLoadOnError" />
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-3">
        <div class="btn-group" role="group" aria-label="Basic example">
          <button @click="prev" type="button" class="btn btn-secondary">Previous</button>
          <button @click="pause" type="button" class="btn btn-secondary">{{ paused ? "Resume" : "Pause" }}</button>
          <button @click="next" type="button" class="btn btn-secondary">Next</button>
        </div>
      </div>
    </div>
  </div>
</template>
